var _g, _circle, _circle2, _circle3, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLanggraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "LangGraph \u2014 mark + wordmark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 28 L21 18 L29 22",
    stroke: "#6F5CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 18 L33 16",
    stroke: "#2DD4BF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 28,
    r: 3.2,
    fill: "#8F7BFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 18,
    r: 4,
    fill: "#6F5CFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 22,
    r: 2.8,
    fill: "#2DD4BF"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 24,
    y: 41,
    fontFamily: "Inter, Helvetica, Arial, sans-serif",
    fontWeight: 600,
    fontSize: 6.2,
    fill: "#E9E8FF",
    textAnchor: "middle",
    dominantBaseline: "middle"
  }, "LangGraph")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanggraph);
export default __webpack_public_path__ + "static/media/langgraph.bf9834977da6e3ed88bb99189efb1308.svg";
export { ForwardRef as ReactComponent };